import { truncate } from 'lodash-es';
import type { PersonalMeetingData } from '../types';
import { LOBBY_MESSAGE_MAX_LENGTH, MEETING_ID_MAX_LENGTH, PASSCODE_MAX_LENGTH } from './constants';

/**
 * Remove non-alphanumeric characters and limit length
 */
export const sanitizeMeetingId = (value: string): string => {
  return value.replace(/[^A-Za-z0-9]/g, '').slice(0, MEETING_ID_MAX_LENGTH);
};

/**
 * Remove non-digit characters and limit length
 */
export const sanitizePasscode = (value: string): string => {
  return value.replace(/[^0-9]/g, '').slice(0, PASSCODE_MAX_LENGTH);
};

/**
 * Truncate lobby message to max length
 */
export const truncateLobbyMessage = (message: string, limit: number): string => {
  return truncate(message, { length: limit, omission: '' });
};

/**
 * Sanitize all meeting data fields before sending to server
 */
export const sanitizeMeetingData = (data: PersonalMeetingData): PersonalMeetingData => {
  return {
    ...data,
    meetingId: sanitizeMeetingId(data.meetingId),
    passcode: sanitizePasscode(data.passcode),
    lobbyMessage: truncateLobbyMessage(data.lobbyMessage, LOBBY_MESSAGE_MAX_LENGTH),
  };
};
